require('es6-object-assign').polyfill();

window.Vue = require('vue');

window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
} catch (e) {
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');
window.appVersion = '';

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.interceptors.request.use(
    (config) => {
        let token = localStorage.getItem('authToken');
        if (token) config.headers['Crm-Auth'] = `Token ${token}`;

        const mixApiUrl = process.env.MIX_API_URL;
        if (mixApiUrl && config.url) {
            const localApiBase = window.location.origin + '/api';
            if (config.url.startsWith(localApiBase)) {
                config.url = config.url.replace(localApiBase, mixApiUrl);
            }
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

axios.interceptors.response.use(response => {
    let version = response.headers['x-app-version'];
    if (window.appVersion === '') {
        window.appVersion = version;
    } else if (window.appVersion !== version) {
        let div = document.getElementById('new-version-alert');
        div.style.display = 'block';
        window.appVersion = version;
    }
    return response;
});
